<template>
  <div :class="['message']">
    <div class="timestamp">{{ format(new Date(message.createdAt), 'HH:mm') }}</div>
    <div class="content">
      <div class="body">&raquo; {{ message.body }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MessageDto } from '@/core/data/chat/chat.interface';
import { format } from 'date-fns';

export interface MessageProps {
  message: MessageDto;
  isSameAsPrev?: boolean;
  prevUsername?: string;
  isEven?: boolean;
}

const { message } = defineProps<MessageProps>();
</script>

<style lang="scss" scoped>
.message {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  &.same-as-prev {
    margin-top: calc(var(--spacing-md) * -1);
  }
}

.content {
  display: flex;
  flex-direction: column;
}

.sender {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: var(--color-white-100);
  letter-spacing: 0.03em;
}
.message:not(.current-user) .sender {
  color: var(--color-white-30);
}
.same-as-prev .sender {
  display: none;
}

.body {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.02em;
  transform: translateX(2px);
  color: var(--color-white-30);
  color: var(--color-pink);
  padding-right: var(--spacing-xxl);
  // font-weight: 300;
  font-weight: 400;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-wrap: balance;
}

.timestamp {
  font-size: 11px;
  line-height: 24px;
  color: var(--color-white-30);
  transform: translateY(1px);
  letter-spacing: 0.1em;
  width: var(--spacing-xxl);
  flex-shrink: 0;
}

.same-as-prev .timestamp {
  transform: translateY(4px);
  opacity: 0;
}
</style>
